'use strict';

import MyApi from '@api/my';
import objToFormData from "@helpers/objToFormData";
import HelperDate from "@helpers/dates";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::my::events]';

const getEvents = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventIndex();
    LoggerBus.$log.debug(loggerFormat, response);
    return response.data;
};

const storeEvent = async(event) => {
    LoggerBus.$log.debug(loggerFormat);
    const headers = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };

    event.reminders.forEach(element => {
        element.value = parseInt(element.value,10).toString();
    });

    const formData = objToFormData(event);
    const response = await MyApi.eventStore(formData, headers);
    return response.data;
}

const showEvent = async (eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventShow(eventId);
    return parseDataForShow(response.data);
}

const updateEvent = async (eventId, event) =>{
    LoggerBus.$log.debug(loggerFormat);
    const headers = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };

    event.reminders.forEach(element => {
        element.value = parseInt(element.value,10).toString();
    });

    const formData = objToFormData(event);
    formData.append('_method', 'PUT');
    const response = await MyApi.eventUpdate(eventId, formData, headers);
    return parseDataForShow(response.data);
}

const parseDataForShow = (event) => {
    event.expiry_at = HelperDate.formatDate(event.expiry_at);
    event.issued_at = HelperDate.formatDate(event.issued_at);
    event.reminders.forEach(reminder => {
        reminder.value = reminder.value.toString();
    });
    // LoggerBus.$log.debug(loggerFormat, event);
    return event;
}

const activateEvent = async (eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventActivate(eventId);
    return response.data;
}

const deactivateEvent = async (eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventDeactivate(eventId);
    return response.data;
}

const deleteEvent = async (eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventDestroy(eventId);
    return response.data;
}

const deleteFile = async (eventId, fileId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventDestroyFile(eventId, fileId);
    return response.data;
}

const downloadFile = async (eventId, fileId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventDownloadFile(eventId, fileId);
    return response;
}

export default {
    getEvents,
    storeEvent,
    showEvent,
    updateEvent,
    activateEvent,
    deactivateEvent,
    deleteEvent,
    deleteFile,
    downloadFile,
};